export default (app) => {
  // Instantiate Wistia queue
  window._wq = window._wq || []
}
